/**
 * Budget cycles (FSD 2.2.5 F06 Open Cycle). INT spreads `BUDGET_CYCLE_ROUTES`
 * into the module's root route table and redirects `/budget/models` and
 * `/budget/models/:id` here: a cycle is the budget model row, so the ids carry
 * over unchanged.
 */

import type { RouteRecordRaw } from 'vue-router'

import { BUDGET_PERMISSIONS } from '@/modules/budget/permissions'

export const BUDGET_CYCLE_ROUTES: RouteRecordRaw[] = [
  {
    path: '/budget/cycles',
    name: 'budget-cycles',
    component: () => import('@/modules/budget/cycles/CyclesListView.vue'),
    meta: { titleKey: 'budget.routeTitles.budgetCycles', permission: BUDGET_PERMISSIONS.modelRead },
  },
  {
    path: '/budget/cycles/:id(\\d+)',
    name: 'budget-cycle',
    component: () => import('@/modules/budget/cycles/CycleView.vue'),
    meta: { titleKey: 'budget.routeTitles.budgetCycle', permission: BUDGET_PERMISSIONS.modelRead },
  },
]

export function cyclesRoute(): string {
  return '/budget/cycles'
}

export function cycleRoute(id: number): string {
  return `/budget/cycles/${id}`
}
